import axios from "axios";

import type {
  IFIAuthenticateRequest,
  IFIAuthenticateResponse,
  IFIFinalizeRequest,
  IFIFinalizeResponse,
  IFIInitializeResponse,
} from "./types";

// Create axios instance without interceptors to avoid circular dependencies
const bankIDApiClient = axios.create({
  baseURL: import.meta.env.API_ROOT_URL,
});

/**
 * Initialize FI BankID - fetches list of available banks
 */
export const initializeFI = async () => {
  return await bankIDApiClient.post<IFIInitializeResponse>(
    "/api/fi/v1/identity/initialize",
  );
};

/**
 * Start authentication with selected bank
 * Returns the OAuth URL to redirect the user to
 */
export const authenticateViaFI = async (params: IFIAuthenticateRequest) => {
  return await bankIDApiClient.post<IFIAuthenticateResponse>(
    "/api/fi/v1/identity/authenticate",
    params,
  );
};

/**
 * Finalize authentication after OAuth callback
 * Exchanges the code for access and refresh tokens
 */
export const finalizeFI = async (params: IFIFinalizeRequest) => {
  return await bankIDApiClient.post<IFIFinalizeResponse>(
    "/api/fi/v1/identity/finalize",
    params,
  );
};
